import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { faUserCircle } from '@fortawesome/free-regular-svg-icons';
import { faTicketAlt, faUser, faPlus } from '@fortawesome/free-solid-svg-icons';

import { NewTicketComponent } from 'src/app/popup/new-ticket/new-ticket.component';
import { OpenticketComponent } from 'src/app/popup/openticket/openticket.component';
import { WaitingticketComponent } from 'src/app/popup/waitingticket/waitingticket.component';


import { GlobalService } from 'src/app/services/global.service';
import { TicketService } from 'src/app/services/ticket.service';
import { element } from 'protractor';

@Component({
  selector: 'app-ticket',
  templateUrl: './ticket.component.html',
  styleUrls: ['./ticket.component.css']
})
export class TicketComponent implements OnInit {

  //string
  token: string;
  activeUser: any;
  // Boolean
  operator: boolean = false;
  noTickets: boolean = true;
  //array
  tickets: Array<any> = [];
  competences: Array<any> = [];
  // Icone
  faUserCircle = faUserCircle;
  faTicketAlt = faTicketAlt;
  faUser = faUser;
  faPlus = faPlus;

  //any
  temp: any;

  tticket = true;
  aticket = false;

  constructor(
    private modalService: NgbModal,
    private globals: GlobalService,
    private ticketService: TicketService,
  ) { }

  ngOnInit() {
    this.globals.checkPage(5);
    if (!this.token) {
      this.token = this.globals.getToken();
    }
    this.activeUser = this.globals.storagedUser;
    this.checkProfile();
    this.getTickets();
    this.inizio();
  }

  // Controllo il profilo
  checkProfile() {
    if (this.activeUser.profile_id == 2 || this.activeUser.profile_id == 3)
      this.operator = true;
  };

  inizio() {
    var element = document.getElementById(`ticketT`);
    element.classList.add("color-change");
    this.temp = "ticketT";
    this.tticket = true;
    this.aticket = false;
    this.getTickets();
  }

  // ricarico la pagina
  reload() {
    if (this.temp) {
      var element = document.getElementById(this.temp);
      element.classList.remove("color-change");
    }
    // this.checkProfile(); 
    // this.getTickets();
    this.ngOnInit();
  }


  // Creo nuovo ticket
  newTicket() {
    const modalRef = this.modalService.open(NewTicketComponent, { backdrop: 'static', centered: true, size: 'xl' });
    modalRef.result.then(result => {
      this.reload();
    }, reason => {
    })
  }

  changeTime(time) {
    time.forEach((dat) => {
      let date = new time(dat.createdat);
      if (date.getMonth() + 1 > 10 && date.getDate() >= 10) {
        dat.createdat = '' + (date.getDate()) + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
        // console.log("mese e giorno >10")
      } else {

        if (date.getMonth() + 1 < 10 && date.getDate() < 10) {
          dat.createdat = '' + (date.getDate()) + '/' + '0' + (date.getMonth() + 1) + '/' + '0' + date.getFullYear();
          // console.log("mese e giorno <10")
        } else {

          if (date.getMonth() + 1 < 10) {
            dat.createdat = '' + (date.getDate()) + '/' + '0' + (date.getMonth() + 1) + '/' + date.getFullYear();
            // console.log("mese <10")
          }

          if (date.getDate() < 10) {
            dat.createdat = '' + (date.getDate()) + '/' + (date.getMonth() + 1) + '/' + '0' + date.getFullYear();
            // console.log("giorno <10")
          }
        }
      }
    })
  }

  // Ottengo i ticket
  getTickets() {
    this.ticketService.getTickets(this.token).subscribe(
      res => {
        if (res.error) {
          return this.globals.errorSniffer(res.error)
        } else {
          this.tickets = res.tickets;
          this.competences = res.competences;
          if (this.tickets.length == 0) {
            this.noTickets = true;
          } else {
            this.noTickets = false;
          }
        }
      },
      err => {
        console.error("Errore in GetTickets", err);

      }
    )
  }

  // Ottengo i ticket assegnati all'operatore
  getMyTickets() {
    this.ticketService.getAssignedTicket(this.token).subscribe(
      res => {
        this.tickets = res;
      },
      err => {
        console.error("Errore: ", err);

      }
    )
  }

  // PopUpTicket Da Assegnare
  showOpenTicket(ticket) {
    const modalRef = this.modalService.open(OpenticketComponent, { backdrop: 'static', centered: true, size: 'xl' });
    modalRef.componentInstance.tk = ticket;
    modalRef.result.then(result => {

      if (result != 'cancel') {
        this.reload();
      }

    }, reason => {
    })
  }

  // popUp DeiTicket già assegnati 
  showWaitingTicket(ticket) {
    const modalRef = this.modalService.open(WaitingticketComponent, { backdrop: 'static', centered: true, size: 'xl' });
    modalRef.componentInstance.tk = ticket;
    modalRef.result.then(result => {

      if (result != 'cancel') {
        this.reload();
      }

    }, reason => {
    })
  }

  // Seleziona la pagina
  page(pagina: string) {

    if (pagina == "tticket") {
      if (this.temp) {
        var elementTwo = document.getElementById(this.temp);
        elementTwo.classList.remove("color-change");
      }

      var element = document.getElementById(`ticketT`);
      element.classList.add("color-change");

      this.temp = "ticketT";
    }

    if (pagina == "aticket") {
      if (this.temp) {
        var element = document.getElementById(this.temp);
        element.classList.remove("color-change");
      }

      var element = document.getElementById(`ticketA`);
      element.classList.add("color-change");

      this.temp = "ticketA";
    }


    switch (pagina) {
      case 'tticket':
        this.tticket = true;
        this.aticket = false;
        this.getTickets();
        break;
      case 'aticket':
        this.aticket = true;
        this.tticket = false;
        this.getMyTickets();
        break;
    }
  }

}